export const serializer = (obj) => {
    let str = ''
    for(i in obj) {
        str += `&${i}=${obj[i]}`
    }
    return str.slice(1)
}




export const dateHelper = {
    isMonmentAgo (diff) {
      return diff <= 60000
    },
    isSameHour (diff) {
      return diff <= 3600000
    },
    minutesFromNow (diff) {
      return Math.round((diff) / 60000)
    },
    hoursFromNow (diff) {
        return Math.round((diff) / (60000 * 60))
    },
    daysFromNow (diff) {
    return Math.round((diff) / (60000 * 60 * 24))
    },
    mouthsFromNow (diff) {
    return parseInt((diff) / (60000 * 60 * 24 * 30))
    }
}


// WEBPACK FOOTER //
// ./src/assets/utils.js